// extracted by mini-css-extract-plugin
export default {"semTalkReportFilter":"SemTalkReportFilter_semTalkReportFilter__qs7ax"};